// extracted by mini-css-extract-plugin
export var baseTextAltGlobal = "content-page-module--base-text-alt--global--1dd02";
export var baseTextGlobal = "content-page-module--base-text--global--df763";
export var blockSpacing100 = "content-page-module--block-spacing-100--6a8e6";
export var blockSpacing50 = "content-page-module--block-spacing-50--1b1c1";
export var blockVPadding100 = "content-page-module--block-v-padding-100--cfe5d";
export var blockVPadding50 = "content-page-module--block-v-padding-50--bf815";
export var captionTextGlobal = "content-page-module--caption-text--global--a1367";
export var cmsRenderedContentGlobal = "content-page-module--cms-rendered-content--global--2af1e";
export var defaultHSpacingGlobal = "content-page-module--default-h-spacing--global--286b4";
export var fadeInAnimation = "content-page-module--fadeInAnimation--1ef38";
export var fadeInOnLoadGlobal = "content-page-module--fade-in-on-load--global--4edd5";
export var fullHeightGlobal = "content-page-module--full-height--global--87fcd";
export var fullHeightOmittingNavGlobal = "content-page-module--full-height-omitting-nav--global--13f10";
export var headingTextGlobal = "content-page-module--heading-text--global--05e1a";
export var ingressTextGlobal = "content-page-module--ingress-text--global--a78cb";
export var linkColorChangeTransitionGlobal = "content-page-module--link-color-change-transition--global--34d26";
export var mobileNavBarHeight = "85px";
export var pageHeadingTextGlobal = "content-page-module--page-heading-text--global--e70ba";
export var paragraphTextGlobal = "content-page-module--paragraph-text--global--6b437";
export var renderedBody = "content-page-module--renderedBody--4a7ba";
export var subheadingTextGlobal = "content-page-module--subheading-text--global--0a9e5";